import React, { Component } from "react";
import '../../styles/css/App.css';
import '../../styles/css/board.css';
import GlassCard from '../GlassCard';

class CardTerrain extends Component{

    render(){
        return (
            <div className="rev-row ">
                <div className="card card--raised with-shadow">
                   
                     <div >
                            {this.props.body}
                           
                        </div>
                
                </div>
            </div>
            )
    }
}


export default CardTerrain;